import { Box, Button } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

interface UpsellModalButtonProps {
  openUpsellModal: () => void
}

export const UpsellModalButton = ({ openUpsellModal }: UpsellModalButtonProps) => {
  return (
    <Box paddingTop="s12">
      <Button type="upgrade" onClick={openUpsellModal}>
        {i18n.t('marketplace.integrations.show_upsell_modal')}
      </Button>
    </Box>
  )
}
